__turbopack_context__.v({
  "attentionIcon": "styles-module-scss-module__br0f1a__attentionIcon",
  "cardVerificationAttention": "styles-module-scss-module__br0f1a__cardVerificationAttention",
  "cardVerificationSelect": "styles-module-scss-module__br0f1a__cardVerificationSelect",
  "cardVerificationStatus": "styles-module-scss-module__br0f1a__cardVerificationStatus",
  "checkboxIcon": "styles-module-scss-module__br0f1a__checkboxIcon",
  "inProgressIcon": "styles-module-scss-module__br0f1a__inProgressIcon",
  "root": "styles-module-scss-module__br0f1a__root",
  "rules": "styles-module-scss-module__br0f1a__rules",
  "submitButton": "styles-module-scss-module__br0f1a__submitButton",
  "trustedPartners": "styles-module-scss-module__br0f1a__trustedPartners",
  "verifiedIcon": "styles-module-scss-module__br0f1a__verifiedIcon",
});
